import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * StructuredData Component
 * Adds JSON-LD structured data to pages for better SEO
 *
 * @param {Object} props
 * @param {Object|Array} props.data - Schema.org structured data object(s)
 */
const StructuredData = ({ data }) => {
  // Handle both single object and array of objects
  const schemas = Array.isArray(data) ? data : [data];

  return (
    <Helmet>
      {schemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
